import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f9a7022&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=1f9a7022&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9a7022')) {
      api.createRecord('1f9a7022', component.options)
    } else {
      api.reload('1f9a7022', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1f9a7022&", function () {
      api.rerender('1f9a7022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assignationMultiple/index.vue"
export default component.exports